// extracted by mini-css-extract-plugin
module.exports = {"main":"MultipleProducts_main_10yTf","productsContainer":"MultipleProducts_productsContainer_31jTN"};